import React, { useState, useContext, useEffect } from 'react';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Search from 'src/components/Form/search';
import { SearchFilter } from 'src/helper/search';
import { ConfigContext } from 'src/contexts/ConfigContext';
import { sanitizeValue } from 'src/utils/custom-formatters';
import { useMyntraContext } from 'src/contexts/MyntraContext';
import { useCookies } from 'react-cookie';
import AccountsReset from './AccountsReset';
import { getCountryFlagUrl } from 'src/utils/utils';

export default function MyntraProfiles() {

  const { myntraState, myntraDispatch } = useMyntraContext()
  const [cookies, setCookie, removeCookie] = useCookies();
  const [showAccDropdown, setShowAccDropdown] = useState(false);
  const myntraProfile = JSON.parse(sessionStorage.getItem('myntraProfile'))
  const [defaultActive, setDefaultActive] = useState(myntraProfile ? myntraProfile : {})
  const [valueSearch, setValueSearch] = useState("")
  const [getProfiles, setProfiles] = useState({
    data: Array.isArray(myntraState?.myntraProfiles) ? myntraState?.myntraProfiles : [],
    filteredData: []
  })

  useEffect(() => {
    setProfiles({
      data: myntraState?.myntraProfiles,
      filteredData: []
    })
    let profile = JSON.parse(sessionStorage.getItem('myntraProfile'))
    setDefaultActive(profile)
  }, [myntraState?.myntraProfiles])
  
  const configContext = useContext(ConfigContext);
  const { rtlLayout } = configContext.state;

  useEffect(() => {
    setValueSearch("")
    setProfiles({
      data: Array.isArray(myntraState?.myntraProfiles) ? myntraState?.myntraProfiles : [],
      filteredData: []
    })
  }, [myntraState?.myntraProfiles])

  useEffect(() => {
    // DISABLED: sessionStorage is tab-specific, no need to reload on focus
    /*
    let reloadTimeout = null;
    let lastFocusTime = 0;
    const RELOAD_DEBOUNCE_TIME = 5000; // 5 seconds minimum between reloads

    const handleWindowFocus = () => {
      const now = Date.now();
      
      // Prevent reload if we just focused recently
      if (now - lastFocusTime < RELOAD_DEBOUNCE_TIME) {
        console.log('Myntra window focus ignored - too recent');
        return;
      }
      
      lastFocusTime = now;
      
      // Clear any existing timeout
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
      }
      
      // Debounce the reload check
      reloadTimeout = setTimeout(() => {
        try {
          const localProfile = JSON.parse(sessionStorage.getItem('myntraProfile'));
          if (defaultActive && localProfile && localProfile?.Value !== defaultActive.Value) {
            console.log('Myntra profile mismatch detected, reloading...', { localProfile, defaultActive });
            window.location.reload();
          } else {
            console.log('Myntra profile sync check passed');
          }
        } catch (error) {
          console.error('Error in Myntra window focus handler:', error);
        }
      }, 1000); // 1 second delay to prevent rapid reloads
    }
    
    window.addEventListener('focus', handleWindowFocus);
    return () => {
      if (reloadTimeout) {
        clearTimeout(reloadTimeout);
      }
      window.removeEventListener('focus', handleWindowFocus);
    };
    */
  }, [defaultActive]);


  const getTableRows = () => {
    if (valueSearch !== '') {
      return getProfiles.filteredData;
    } else {
      return getProfiles.data;
    }
  };

  const searchInputHandle = async (e) => {
    const keyword = sanitizeValue(e.target.value);
    console.log("keyword", keyword);
    const { data, filteredData } = await SearchFilter(getProfiles.data, keyword);

    if (keyword !== '') {
        setProfiles({ data, filteredData });
    }
    else {
        setProfiles({ data, filteredData });
    }
    setValueSearch(keyword);
  }

  const handleSelect = (selectedItem) => {
      setShowAccDropdown(!showAccDropdown)
      setDefaultActive(selectedItem)
      sessionStorage.removeItem("myntraProfile")
      sessionStorage.setItem('myntraProfile', JSON.stringify(selectedItem))
      if(window.location.href.indexOf('plan-expired') > -1) {
        window.location.href = '/summary/myntra'
      } else {
        window.location.reload();
      }
  }

  useEffect(() => {
    if (showAccDropdown) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, [showAccDropdown]);

  const profilesList = valueSearch != '' ? getProfiles.filteredData : getProfiles.data;

  console.log("profilesList", getProfiles)

  // if(!defaultActive?.countryCode) return null

  return (
    <ListGroup.Item as="li" bsPrefix="" className='ch_toggle'>
      <Dropdown
        alignRight={!rtlLayout}
        className="select-account"
        show={showAccDropdown}
        onToggle={() => {
          if(profilesList.length > 1) {
            setShowAccDropdown(!showAccDropdown)
          }
        }}
      >
        <Dropdown.Toggle as="li" id="dropdown-basic" onClick={() => {
          if(profilesList.length > 1) {
            setShowAccDropdown(!showAccDropdown)
          }
        }} className='cursor-pointer'>
          <div className="text-right d-flex flex-column l-base align-items-end pr-2 drop-crd">
            <div className="f-w-600 f-14 d-flex align-items-center text-left">
              <img
                alt="country-img"
                src={getCountryFlagUrl(defaultActive?.countryCode)}
                className="country_flag_drop"
              />
              <div className="d-flex flex-column f-10">
                <div className='f-333843'>{defaultActive?.accountInfo?.name}</div>
                {defaultActive?.accessLevel ?
                    <span className="f-10 text-left w-100 f-w-500 spld-bder f-8F8F91">
                      Role: <b className="f-w-600 f-10 f-333843">{defaultActive?.accessLevel}</b>
                    </span>
                  : null}
              </div>
            </div>
            {/* <small className="f-10 bg-blur px-2 py-1 rounded-10 txt-theme">{defaultActive?.map((select) => select?.countryCode)}</small> */}
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu alignRight className="themebg notification notification-scroll">
          <div className="noti-head" style={{
            height: '60px'
          }}>
            {/* <h6 className="d-inline-block m-b-0 f-w-700 f-14 text-dark">ACCOUNTS</h6> */}
            <AccountsReset />
          </div>
          <div className="px-3 pt-3 pb-1">
            <Search searchValue={valueSearch} callBack={searchInputHandle} />
          </div>
          <PerfectScrollbar className="min-hight-150 max-height-300">
            <ListGroup as="ul" bsPrefix=" " variant="flush" className="noti-body">
                {profilesList && profilesList.map((AMSprofiles, index) => (
                  <ListGroup.Item
                    as="li"
                    bsPrefix=" "
                    className={'n-title px-0 pt-2'}
                    key={index}
                    onClick={() => handleSelect(AMSprofiles)}
                  >
                    <Link
                      to="#"
                      className={`dropdown-item d-flex align-items-center justify-content-between ${
                        defaultActive?.profileId == AMSprofiles.profileId ? 'active' : ''
                      }`}
                    >
                      <section className="d-flex align-items-center" title={AMSprofiles?.accountInfo?.name} >
                        <img
                          src={getCountryFlagUrl(AMSprofiles?.countryCode)}
                          alt=""
                          className="wid-30 hei-25 mr-4"
                        />

                        <div>
                          <h4 className="f-w-600 f-14 d-flex align-items-center profile-name-truncate fk_myntra_width">
                            {' '}
                            {AMSprofiles?.accountInfo?.name}{' '}
                            {/* <p className={`f-w-500 f-14 ml-2 ${AMSprofiles?.accountInfo?.type === 'seller' ? 'txt-theme' : 'text-success'} `}>
                              ({AMSprofiles?.accountInfo?.type})
                            </p> */}
                          </h4>

                          {/* {AMSprofiles.accessLevel ? (
                            <p className="f-13 mb-0 f-w-500">
                              Role: &nbsp; <b className="f-w-600 pr-1">{AMSprofiles.accessLevel}</b> |{' '}
                            </p>
                          ) : (
                            ''
                          )} */}
                          {/* <p className="f-13 mb-0 f-w-500">{AMSprofiles.profileId}</p> */}
                          {/* <p className="f-12 text-secondary f-w-500 d-flex align-items-center"> */}
                        </div>
                      </section>
                    </Link>
                  </ListGroup.Item>
                ))}
                {profilesList && profilesList.length === 0 && (
                  <div className="hei-300 w-100 d-flex align-items-center justify-content-center f-w-700 txt-danger">
                    {' '}
                    No Profiles Found
                  </div>
                )}
            </ListGroup>
          </PerfectScrollbar>
          {/* <div className="noti-footer py-2 text-left">
            <Link to="/profile" className="mb-1">
              Manage Your Accounts
            </Link>
            <br />
            <Link to="/addaccount">Add a new account</Link>
          </div> */}
        </Dropdown.Menu>
      </Dropdown>
    </ListGroup.Item>
  );
}
